import React, { createContext, useState, useContext } from 'react';
const initialStore = {
    name: '',
    brand: '',
    activeShade: undefined,
    shades: [],
};
const AppStore = createContext(initialStore);
export const StoreProvider = (props) => {
    const [state, setState] = useState(initialStore);
    const setProduct = (name, brand, shades) => {
        setState(Object.assign(Object.assign({}, state), { name,
            brand,
            shades, activeShade: shades.length > 0 ? shades[0] : undefined }));
    };
    const setActiveShade = (code) => {
        const activeShade = state.shades.find((shade) => shade.code === code);
        setState(Object.assign(Object.assign({}, state), { activeShade }));
    };
    const value = Object.assign(Object.assign({}, state), { setProduct,
        setActiveShade });
    return React.createElement(AppStore.Provider, { value: value }, props.children);
};
export const useStore = () => useContext(AppStore);
